import React, {useContext, useEffect, useState} from 'react'
import background from "../../../../images/bg_yellow_flower_field.jpg";
import {Box, Typography} from "@mui/material";
import ModifyService from "../service/ModifyService/ModifyService";
import {authModifySignCheck} from "../../../../api";
import RequiredAuthModify from "../../RequiredService/main/RequiredAuthModify";
import {Desktop, Mobile, Tablet} from "../../../../containers/Responsive/responsive";
import {MainContext} from "../../../../context";




export default function ModifyComponent(props){

    const { userData, srcAddress, CheckCompany } = props;

    const [isAuthModify,setIsAuthModify] = useState(false)
    const [res,setRes]=useState('')
    const { toggleClose } = useContext(MainContext)

    useEffect(()=>{
        authModifySignCheck()
            .then((res)=>{
                setIsAuthModify(true)
                setRes(res.data)
            })
            .catch((err)=>{
            })
    },[])

    const [isMarginTop, setIsMarginTop] =useState(false)
    const [isSunil, setIsSunil] = useState(false)

    useEffect(()=>{
        if(CheckCompany === 'LG HelloVision'){
            setIsMarginTop(true)
        }else if(CheckCompany === 'LG U+'){
            setIsMarginTop(true)
        }else if(CheckCompany === 'Blaubit'){
            setIsMarginTop(true)
        }else if(CheckCompany === 'Sunil'){
            setIsMarginTop(true)
            setIsSunil(true)
        }else{
            setIsMarginTop(false)
        }
    },[])


    return (
        <div onClick={toggleClose}>
            {isAuthModify ? (
                <>

                    <Desktop>
                        <div style={{
                            backgroundImage: `url(${background})`,
                            paddingBottom: 350
                        }}><br/>
                            <div style={{
                                display: 'flex',
                                flexDirection: "column",
                                alignItems: "center",
                            }}>
                                {isMarginTop ? (
                                    <Box
                                        sx={{
                                            marginTop: 3,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            backgroundColor: 'white',
                                            height: '700px',
                                            width: '500px',
                                            borderRadius: '0.5rem'
                                        }}
                                    ><br/>
                                        {isSunil ? (
                                            <>
                                                <img alt="No Images" src={srcAddress}
                                                     style={{
                                                         marginTop: 1,
                                                         paddingBottom: 30,
                                                         width:200
                                                     }}/>
                                            </>
                                        ):(
                                            <>
                                                <img alt="No Images" src={srcAddress}
                                                     style={{
                                                         marginTop: 1,
                                                         paddingBottom: 30
                                                     }}/>
                                            </>
                                        )}
                                        <img alt="No Images" src="images/img_logo_main.png"
                                             style={{
                                                 display: 'flex',
                                                 alignItems: "center",
                                                 width: "250px",
                                                 paddingBottom: 30
                                             }}/>
                                        <div style={{paddingBottom: 30}}>
                                            <Typography component="h3" variant="h7">
                                                계약자 정보 수정 / 회원 탈퇴
                                            </Typography>
                                        </div>
                                        <ModifyService userData={userData} srcAddress={srcAddress}
                                                       CheckCompany={CheckCompany}/>
                                    </Box>

                                ) : (

                                    <Box
                                        sx={{
                                            marginTop: 3,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            backgroundColor: 'white',
                                            height: '700px',
                                            width: '500px',
                                            borderRadius: '0.5rem'
                                        }}
                                    ><br/>
                                        <img alt="No Images" src={srcAddress}
                                             style={{
                                                 marginTop: 1,
                                                 paddingBottom: 30
                                             }}/>
                                        <img alt="No Images" src="images/img_logo_main.png"
                                             style={{
                                                 display: 'flex',
                                                 alignItems: "center",
                                                 width: "250px",
                                                 paddingBottom: 30
                                             }}/>
                                        <div style={{paddingBottom: 30}}>
                                            <Typography component="h3" variant="h7">
                                                계약자 정보 수정 / 회원 탈퇴
                                            </Typography>
                                        </div>
                                        <ModifyService userData={userData} srcAddress={srcAddress}
                                                       CheckCompany={CheckCompany}/>
                                    </Box>

                                )}
                            </div>
                        </div>
                    </Desktop>

                    <Tablet>
                        <div style={{
                            backgroundImage: `url(${background})`,
                            backgroundSize:'cover',
                            paddingBottom: 600
                        }}><br/>
                            <div style={{
                                display: 'flex',
                                flexDirection: "column",
                                alignItems: "center",
                            }}>
                                {isMarginTop ? (

                                    <Box
                                        sx={{
                                            marginTop: 20,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            backgroundColor: 'white',
                                            height: '700px',
                                            width: '450px',
                                            borderRadius: '0.5rem'
                                        }}
                                    ><br/>
                                        {isSunil ? (
                                            <>
                                                <img alt="No Images" src={srcAddress}
                                                     style={{
                                                         marginTop: 1,
                                                         paddingBottom: 30,
                                                         width:190
                                                     }}/>
                                            </>
                                        ):(
                                            <>
                                                <img alt="No Images" src={srcAddress}
                                                     style={{
                                                         marginTop: 1,
                                                         paddingBottom: 30
                                                     }}/>
                                            </>
                                        )}
                                        <img alt="No Images" src="images/img_logo_main.png"
                                             style={{
                                                 display: 'flex',
                                                 alignItems: "center",
                                                 width: "200px",
                                                 paddingBottom: 30
                                             }}/>
                                        <div style={{paddingBottom: 30}}>
                                            <Typography component="h4" variant="h8">
                                                계약자 정보 수정 / 회원 탈퇴
                                            </Typography>
                                        </div>
                                        <ModifyService userData={userData} srcAddress={srcAddress}
                                                       CheckCompany={CheckCompany}/>
                                    </Box>

                                ) : (

                                    <Box
                                        sx={{
                                            marginTop: 20,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            backgroundColor: 'white',
                                            height: '700px',
                                            width: '450px',
                                            borderRadius: '0.5rem'
                                        }}
                                    ><br/>
                                        <img alt="No Images" src={srcAddress}
                                             style={{
                                                 marginTop: 1,
                                                 paddingBottom: 30
                                             }}/>
                                        <img alt="No Images" src="images/img_logo_main.png"
                                             style={{
                                                 display: 'flex',
                                                 alignItems: "center",
                                                 width: "200px",
                                                 paddingBottom: 30
                                             }}/>
                                        <div style={{paddingBottom: 30}}>
                                            <Typography component="h4" variant="h8">
                                                계약자 정보 수정 / 회원 탈퇴
                                            </Typography>
                                        </div>
                                        <ModifyService userData={userData} srcAddress={srcAddress}
                                                       CheckCompany={CheckCompany}/>
                                    </Box>

                                )}
                            </div>
                        </div>
                    </Tablet>


                    <Mobile>
                        <div style={{
                            backgroundImage: `url(${background})`,
                            paddingBottom: 350
                        }}><br/>
                            <div style={{
                                display: 'flex',
                                flexDirection: "column",
                                alignItems: "center",
                            }}>
                                {isMarginTop ? (
                                    <Box
                                        sx={{
                                            marginTop: 3,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            backgroundColor: 'white',
                                            height: '750px',
                                            width: '350px',
                                            borderRadius: '0.5rem'
                                        }}
                                    ><br/>
                                        {isSunil ? (
                                            <>
                                                <img alt="No Images" src={srcAddress}
                                                     style={{
                                                         marginTop: 1,
                                                         paddingBottom: 30,
                                                         width:170
                                                     }}/>
                                            </>
                                        ):(
                                            <>
                                                <img alt="No Images" src={srcAddress}
                                                     style={{
                                                         marginTop: 1,
                                                         paddingBottom: 30
                                                     }}/>
                                            </>
                                        )}

                                        <img alt="No Images" src="images/img_logo_main.png"
                                             style={{
                                                 display: 'flex',
                                                 alignItems: "center",
                                                 width: "200px",
                                                 paddingBottom: 30
                                             }}/>
                                        <div style={{paddingBottom: 30}}>
                                            <Typography component="h5" variant="h8">
                                                계약자 정보 수정 / 회원 탈퇴
                                            </Typography>
                                        </div>
                                        <ModifyService userData={userData} srcAddress={srcAddress}
                                                       CheckCompany={CheckCompany}/>
                                    </Box>
                                ) : (
                                    <Box
                                        sx={{
                                            marginTop: 3,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            backgroundColor: 'white',
                                            height: '750px',
                                            width: '350px',
                                            borderRadius: '0.5rem'
                                        }}
                                    ><br/>
                                        <img alt="No Images" src={srcAddress}
                                             style={{
                                                 marginTop: 1,
                                                 paddingBottom: 30
                                             }}/>
                                        <img alt="No Images" src="images/img_logo_main.png"
                                             style={{
                                                 display: 'flex',
                                                 alignItems: "center",
                                                 width: "250px",
                                                 paddingBottom: 30
                                             }}/>
                                        <div style={{paddingBottom: 30}}>
                                            <Typography component="h5" variant="h8">
                                                계약자 정보 수정 / 회원 탈퇴
                                            </Typography>
                                        </div>
                                        <ModifyService userData={userData} srcAddress={srcAddress}
                                                       CheckCompany={CheckCompany}/>
                                    </Box>
                                )}
                            </div>
                        </div>
                    </Mobile>

                </>
            ) : (
                <RequiredAuthModify/>
            )}

        </div>
    )

}